export const basicTooltipSubTitle = [
    {
        text: 'Use ',
        code: 'data-bs-toggle="tooltip"'
    },
    {
        text: ' to set the tooltip.'
    }
];

export const coloredTooltipSubTitle = [
    {
        text: 'Add ',
        code: 'btn- *'
    },
    {
        text: ' class to set the colored tooltip.'
    }
];

export const tooltipDirectionSubTitle = [
    {
        text: 'To set different direction use ',
        code: 'data-bs-placement="top/right/bottom/left".'
    }
];

export const htmlTooltipSubTitle = [
    {
        text: 'Use html element with the help of ',
        code: 'data-bs-title="".'
    }
];

export const filledTooltipSubTitle = [
    {
        text: 'Fill the btn on the hover effect with the help of ',
        code: '.btn-outline'
    },
    {
        text: 'class.'
    }
];

export const colorTooltipData = [
    {
        class: 'primary',
        text: 'Primary'
    },
    {
        class: 'secondary',
        text: 'Secondary'
    },
    {
        class: 'success',
        text: 'Success'
    },
    {
        class: 'warning',
        text: 'Warning'
    },
    {
        class: 'danger',
        text: 'Danger'
    }
];

export const tooltipPosition = [
    {
        class: 'primary',
        position: 'top',
        text: 'Top'
    },
    {
        class: 'secondary',
        position: 'right',
        text: 'Right'
    },
    {
        class: 'success',
        position: 'bottom',
        text: 'Bottom'
    },
    {
        class: 'warning',
        position: 'left',
        text: 'Left'
    }
];

export const htmlTooltipData = [
    {
        class: 'primary',
        text: 'Notifications Received',
        tooltip: <><em>Thank</em> <u>you</u></>
    },
    {
        class: 'warning',
        text: 'Last Warning',
        tooltip: <><b>Thank</b> <em>you</em></>
    },
    {
        class: 'danger',
        text: "It's Danger",
        tooltip: <><em>Thank</em> <u>you</u></>
    },
    {
        class: 'info',
        text: 'Coming soon',
        tooltip: <><b>Thank</b> <em>you</em></>
    }
];

export const flippedTooltipData = [
    {
        class: 'primary',
        text: 'Tooltip Primary',
    },
    {
        class: 'secondary',
        text: 'Tooltip Secondary',
    },
    {
        class: 'success',
        text: 'Tooltip Success',
    },
    {
        class: 'info',
        text: 'Tooltip Info',
    }
]
